import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SuperAdminNavbarComponent } from '../../components/superadmin-navbar/superadmin-navbar.component';
import { AdminHotelNavbarComponent } from '../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { HostingService } from '../../services/hosting.service';
import { Hosting } from '../../models/HostingModel';
import { NavbarComponent } from "../../components/navbar/navbar.component";


@Component({
  selector: 'app-create-admin',
  standalone: true,
  imports: [CommonModule, FormsModule, SuperAdminNavbarComponent, AdminHotelNavbarComponent, NavbarComponent],
  templateUrl: './create-admin.component.html',
  styleUrl: './create-admin.component.css',
  providers: [AuthService, HostingService]
})
export class CreateAdminComponent implements OnInit {
  email = '';
  document_number = '';
  family_name = '';
  given_name = '';
  password = '';
  confirmPass = '';
  group: string = '';

  modoAdminHotel = false;

  availableGroups = [
    { value: 'superadmin', label: 'Superadmin' },
    { value: 'admin-hotel', label: 'Admin Hotel' },
    { value: 'admin-recepcion', label: 'Admin Recepción' }
  ];

  hostings: Hosting[] = [];
  selectedHostings: string[] = [];
  loadingHostings = false;
  showHostings = false;

  // Inline message state (instead of alerts)
  message: string | null = null;
  messageType: 'success' | 'error' | 'info' = 'info';

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly hostingService: HostingService,
    private readonly route: ActivatedRoute
  ) {}


  ngOnInit() {
    // Detectar si la ruta tiene modoAdminHotel
    this.route.data.subscribe(data => {
      console.log("HOLAAAA",data)
      this.modoAdminHotel = !!data['modoAdminHotel'];
      if (this.modoAdminHotel) {
        this.group = 'admin-recepcion';
      }
    });
  }

  async loadHostingsIfNeeded() {
    if (this.hostings.length === 0 && !this.loadingHostings) {
      this.loadingHostings = true;
      try {
        this.hostings = await this.hostingService.getAllHostingId();
      } catch (e) {
        this.hostings = [];
      }
      this.loadingHostings = false;
    }
  }

  async register() {
    // Reset previous message
    this.message = null;
    this.messageType = 'info';

    if (this.password !== this.confirmPass) {
      this.message = 'Las contraseñas no coinciden';
      this.messageType = 'error';
      return;
    }
    if (!this.group) {
      this.message = 'Debe especificar el grupo del usuario';
      this.messageType = 'error';
      return;
    }

    if(this.selectedHostings.length==0)
      {
        this.message = 'Debe seleccionar almenos un hosting';
         this.messageType = 'error';
        return;
      }

    // Debug: mostrar alojamientos seleccionados
    console.log('[DEBUG] selectedHostings:', this.selectedHostings);
    let alojamientos_ids: string | undefined = undefined;
    if ((this.group === 'admin-hotel' || this.group === 'admin-recepcion') && this.selectedHostings.length > 0) {
      alojamientos_ids = this.selectedHostings.join(',');
    }
    // Debug: mostrar datos enviados al backend
    console.log('[DEBUG] Datos enviados al backend:', {
      email: this.email,
      password: this.password,
      given_name: this.given_name,
      family_name: this.family_name,
      document_number: this.document_number,
      group: this.group,
      alojamientos_ids
    });
    try {

      
      const response = await this.authService.registerUser(
        this.email,
        this.password,
        this.given_name,
        this.family_name,
        this.document_number.toString(),
        this.group,
        alojamientos_ids
      );
      // Si es un usuario existente y solo se agregó a un grupo, mostrar mensaje y no redirigir
      if (response && (response as any).isExistingUser && (response as any).requiresConfirmation === false) {
        this.router.navigate(['/loggin']);
        return;
      }

      this.router.navigate(['/confirm-registration'], {
        queryParams: { email: this.email }
      });

      this.message = 'Usuario recepcionista creado exitosamente. El usuario debe revisar su correo para la contraseña temporal.';
      this.messageType = 'success';

    } catch (error: any) {
      console.error('Error completo:', error);
      const code = error?.code || error?.raw?.error?.code;
      const status = error?.status;
      const details = error?.details;
      if (code === 'UsernameExistsException') {
        this.message = 'Este correo electrónico ya está registrado';
      } else if (code === 'InvalidPasswordException') {
        this.message = 'La contraseña no cumple con los requisitos de seguridad';
      } else if (status === 0) {
        this.message = error?.message || 'Error de conexión. Verifica tu conexión a internet.';
      } else {
        const extra = Array.isArray(details)
          ? ` Detalles: ${details.join(', ')}`
          : details ? ` Detalles: ${JSON.stringify(details)}` : '';
        this.message = `${error?.message || 'Error en registro.'}${extra}`;
      }
      this.messageType = 'error';
    }
  }

  onAlojamientoCheckboxChange(event: Event, hostingId: string) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      if (!this.selectedHostings.includes(hostingId)) {
        this.selectedHostings.push(hostingId);
      }
    } else {
      this.selectedHostings = this.selectedHostings.filter(id => id !== hostingId);
    }
  }

  toggleHostings() {
  this.showHostings = !this.showHostings;
  if (this.showHostings) {
    this.loadHostingsIfNeeded();
  }
}

}
